module.exports = __webpack_public_path__ + "assets/img/EnterpriseLibrary.78103f77.png";